(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ponytail-classic-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ponytail-substack-offer')) {
    customElements.define('ponytail-substack-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.key = 'ponytail-substack-offer-seen';
        this.onClick = (event) => {
          if (event.target.closest('[data-open]')) this.openOffer();
          if (event.target.closest('[data-close]')) this.dialog.close();
          if (event.target.closest('[data-signup]')) this.dialog.close();
          if (event.target === this.dialog) {
            const box = this.dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
          }
        };
        this.addEventListener('click', this.onClick);
        this.onScroll = () => {
          const focus = document.activeElement;
          if (!this.elapsed || document.visibilityState !== 'visible' || focus?.matches('input, select, textarea, [contenteditable="true"]')) return;
          const otherDialogVisible = Array.from(document.querySelectorAll('[role="dialog"], [role="alertdialog"]')).some((element) => {
            const style = getComputedStyle(element);
            return element.getClientRects().length > 0 && style.visibility === 'visible' && style.display !== 'none' && style.opacity !== '0' && !element.closest('[aria-hidden="true"], details:not([open])');
          });
          if (otherDialogVisible) return;
          const availableScroll = document.documentElement.scrollHeight - window.innerHeight;
          const scrollTarget = Math.min(availableScroll * .45, window.innerHeight * .5);
          if (availableScroll > 0 && window.scrollY < scrollTarget) return;
          this.openOffer();
          window.removeEventListener('scroll', this.onScroll);
        };
        let seen = false;
        try { seen = sessionStorage.getItem(this.key) === '1'; } catch {}
        if (this.dataset.ready === 'true' && this.dataset.autoPopup === 'true' && !seen && !window.Shopify?.designMode) {
          const delay = Math.max(20, Number(this.dataset.delay) || 25) * 1000;
          this.timer = setTimeout(() => {
            this.elapsed = true;
            window.addEventListener('scroll', this.onScroll, { passive: true });
            this.onScroll();
          }, delay);
        }
      }
      openOffer() {
        if (!this.dialog || this.dialog.open || typeof this.dialog.showModal !== 'function') return;
        if (document.querySelector('dialog[open]')) return;
        this.dialog.showModal();
        try { sessionStorage.setItem(this.key, '1'); } catch {}
        clearTimeout(this.timer);
        window.removeEventListener('scroll', this.onScroll);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        window.removeEventListener('scroll', this.onScroll);
        this.removeEventListener('click', this.onClick);
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ponytail-friday-drop"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',function(event){var button=event.target.closest('[data-drop-side]');if(!button)return;var card=button.closest('.pt-drop__card');var showBack=card.dataset.side!=='back';card.dataset.side=showBack?'back':'front';button.setAttribute('aria-pressed',String(showBack));button.textContent=showBack?button.dataset.frontLabel:button.dataset.backLabel;button.setAttribute('aria-label',button.textContent+' — '+card.querySelector('h2').textContent.trim());});

  } catch(e) { console.error(e); }
})();
})();
